import React, { useEffect } from "react";
import { AppModal, CircularLoader } from "../Common";
import { StyledTechnicalDocumentsComponent, TechnicalDocumentsItem } from ".";
// import active_arrow_down from "@assets/Icons/active_arrow_down.svg";
import {
  DOCUMENT_EXCEL_FAILED_TO_LOAD,
  DOCUMENT_FAILED_TO_LOAD,
  LABEL_LIST_DOCUMENT,
  MESSAGE_DATA_NOT_FOUND,
  MESSAGE_LOADING_PDF,
} from "@configs";
import { StyledIframe, StyledPDF } from "../Document";
import { Document, Page } from "react-pdf";
import {
  converNumberToArrayOfInterger,
  isLinkExel,
  linkDocument,
  useWindowDimensions,
} from "@utils";
import { saveAs } from "file-saver";
import { TitleMenuComponent } from "../TitleMenuComponent";
import { technicalDocumentsApi } from "@api";
import { NextButton } from "../Notification";
// import { number } from "yup";

//ファイル名はTechnicalDocumentsViewだが、実際は「個人の通知」ページ

export const TechnicalDocumentsView = () => {

  // 個人通知読み込みはページに応じた読み込み方法などあるためRedux読み込みは一旦廃止
  // const technicalDocuments = useAppSelector(selectTechnicalDocuments);
  //const loading = useAppSelector(selectDocumentsLoading);
  // const preloadData = useAppSelector(selectPreloadData);
  //console.log("preloadData", preloadData);
  // const preloadDataLoading = useAppSelector(selectPreloadDataLoading);
  // const boxDocuments = preloadData?.boxDocuments;

  const [page, setPage] = React.useState<number>(1);
  const [boxDocumentListLoading, setBoxDocumentListLoading] = React.useState<boolean>(false);
  // const history = useHistory();
  // const dispatch = useDispatch();
  // const loadMore = false;
  const [openPDF, setOpenPDF] = React.useState<boolean>(false);
  const [loadMore, setLoadMore] = React.useState<boolean>(false);
  const [linkPdf, setLinkPdf] = React.useState<any>("");
  const [numPages, setNumPages] = React.useState(null);
  const [forceReload, setForceReload] = React.useState<boolean>(false);

  type BoxDocument = {
    id: string | number;
    path: string;
    title: string;
  };

  const [boxDocuments, setBoxDocuments] = React.useState<BoxDocument[]>([]);
  const width = useWindowDimensions().width;

  const fetchListDocument = async () => {
    try {
      setBoxDocumentListLoading(true);
      const res = await technicalDocumentsApi.getBoxDocumentsPage(page);

      setBoxDocuments(prev =>
      page === 1
        ? res.data.data.documents // 1ページ目：リセット
        : [...prev, ...res.data.data.documents] // 2ページ目以降：追加
      );
      
      setBoxDocumentListLoading(false);

      const nowCount = (page === 1 ? 0 : boxDocuments.length) + res.data.data.documents.length;
      if (nowCount >= res.data.data.total) {
        //console.log("setLoadMore", false);
        setLoadMore(false);
      } else {
        //console.log("setLoadMore", true);
        setLoadMore(true);
      }
    } catch (err) {
      setBoxDocumentListLoading(false);
      console.error("一覧読み込み失敗", err);
    }
  };

  useEffect(() => {
      fetchListDocument();
  }, []);

  // 未読アイコン反映
  const handleOnSelectBoxDocuments = async (path: any, title: any, id: any) => {
    try {
      const res = await technicalDocumentsApi.readBoxDocuments({box_document_id : Number(id)});

      if (res.data.success === true) {
        resetAndFetch();
      }

      if (path.endsWith(".xlsx")) {
        const response = await fetch(path);
        const blob = await response.blob();
        saveAs(blob, `${title}.xlsx`);
      } else {
        handleOpenPDF(path);
      }
    } catch (error) {
      console.error("読み込み失敗", error);
    }
  };

  const handleDeleteBoxDocuments = async (id: any) => {
    try {
      const res = await technicalDocumentsApi.deleteBoxDocuments({ box_document_id: [id] });

      if (res.data.success === true) {
        resetAndFetch();
      }

    } catch (err) {
      console.error("削除失敗", err);
     }
  };

  const resetAndFetch = React.useCallback(() => {
    setBoxDocuments([]);
    setPage(1);
    setForceReload(prev => !prev); 
  }, []);

  React.useEffect(() => {
    fetchListDocument();
  }, [page, forceReload]);

  const handleOpenPDF = (value: any) => {
    if (width <= 980) {
      window.location.href = linkDocument(value);
    }
    setLinkPdf(value);
    setOpenPDF(true);
  };

  const handleClosePDF = () => {
    setOpenPDF(false);
    setLinkPdf("");
  };

  const handleLoadMore = () => {
    setPage(page + 1);
  };

  // React.useEffect(() => {
  //   fetchListDocument();
  //   return () => {
  //     //    do something cleanup
  //   };
  // }, [page]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  return (
    <StyledTechnicalDocumentsComponent>
      <CircularLoader loading={boxDocumentListLoading} />
      {width >= 981 && (
        <AppModal open={openPDF} handleClose={handleClosePDF}>
          <StyledPDF>
            {linkPdf ? (
              isLinkExel(linkPdf) ? (
                <p className="failePDF">{DOCUMENT_EXCEL_FAILED_TO_LOAD}</p>
              ) : width >= 991 ? (
                <StyledIframe
                  heightCalculationMethod="lowestElement"
                  src={linkDocument(linkPdf)}
                  log
                  scrolling={true}
                  autoResize={false}
                />
              ) : (
                <Document
                  file={linkDocument(linkPdf)}
                  options={{ workerSrc: "/pdf.worker.js" }}
                  onLoadSuccess={onDocumentLoadSuccess}
                  error={DOCUMENT_FAILED_TO_LOAD}
                  loading={MESSAGE_LOADING_PDF}
                >
                  {numPages &&
                    converNumberToArrayOfInterger(numPages).map(
                      (page, index) => <Page pageNumber={index} />
                    )}
                </Document>
              )
            ) : (
              <p className="failePDF">{DOCUMENT_FAILED_TO_LOAD}</p>
            )}
          </StyledPDF>
        </AppModal>
      )}
      <div className="wrapperForm">
        <div className="top-icon">
          <TitleMenuComponent text={LABEL_LIST_DOCUMENT} />
        </div>
      </div>
      {/* <DocumentBorder /> */}
      <div className="noti">
        <div className="noti__wrapper">
          <div className="noti__content">
            {boxDocuments?.length
              ? boxDocuments.map((noti, index) => (
                <div key={index}>
                  <TechnicalDocumentsItem
                    handleOnSelectBoxDocuments={() =>
                      handleOnSelectBoxDocuments(
                        noti?.path,
                        noti?.title,
                        noti?.id
                      )
                    }
                    data={noti}
                    handleDeleteBoxDocuments={() => {
                      handleDeleteBoxDocuments(noti?.id);
                    }}
                  />
                </div>
              ))
              : !(boxDocumentListLoading) && (
                <p className="messageNotFound">{MESSAGE_DATA_NOT_FOUND}</p>
              )}
          </div>
      {!(boxDocumentListLoading) && loadMore && (
          <span style={{display:"flex", justifyContent:"center"}} onClick={() => handleLoadMore()}>
            <NextButton>
            ↓続きを見る
            </NextButton>
          </span>
      )}
        </div>
      </div>
      {/* <div className="wrapperLoading">
                <CircularLoader loading={loading} size={15} type="fullContent" />
            </div> */}
    </StyledTechnicalDocumentsComponent>
  );
};
